// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

export const asyncRouterMap = [

    {
        path: '/',
        name: 'index',
        component: BasicLayout,
        meta: { title: '首页' },
        // redirect: '/sai/DanweiList',
        redirect: '/dashboard/analysis',
        children: [{
                path: '/dashboard',
                name: 'dashboard',
                redirect: '/wyhSetting/settings',
                component: RouteView,
                meta: { title: '首页', keepAlive: true, icon: 'dashboard', permission: ['dashboard'] },
                children: [{
                        path: '/dashboard/analysis',
                        name: 'Analysis',
                        component: () =>
                            import ('@/views/dashboard/Analysis'),
                        meta: { title: '分析页', keepAlive: false, permission: ['dashboard'] }
                    },

                    {
                        path: '/wyhSetting/settings',
                        name: 'WyhSettingIndex',
                        component: () =>
                            import ('@/views/wyhSetting/WyhSettingIndex'),
                        meta: {
                            title: '设置',
                            hideHeader: true,
                            keepAlive: true,
                            permission: ['dashboard']
                        },
                        redirect: '/wyhSetting/settings/base',
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/wyhSetting/settings/base',
                                name: 'WyhSettingBase',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingBase'),
                                meta: {
                                    title: '基本设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            },
                            {
                                path: '/wyhSetting/settings/user',
                                name: 'WyhSettingUser',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingUser'),
                                meta: {
                                    title: '人员设置',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            },
                            {
                                path: '/wyhSetting/settings/subwyh',
                                name: 'WyhSettingSubwyh',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingSubwyh'),
                                meta: {
                                    title: '下级省市',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            },
                            {
                                path: '/wyhSetting/settings/password',
                                name: 'WyhSettingPassword',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingPassword'),
                                meta: {
                                    title: '修改密码',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            },
                            {
                                path: '/wyhSetting/settings/bank',
                                name: 'WyhSettingBank',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingBank'),
                                meta: {
                                    title: '结算账号管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            },
                            {
                                path: '/wyhSetting/settings/fapiao',
                                name: 'WyhSettingFapiao',
                                component: () =>
                                    import ('@/views/wyhSetting/WyhSettingFapiao'),
                                meta: {
                                    title: '发票信息管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['dashboard']
                                }
                            }
                        ]
                    },
                    {
                        path: '/activity/calendar',
                        name: 'ActivityCalendar',
                        component: () =>
                            import ('@/views/dashboard/ActivityCalendar'),
                        meta: { title: '活动日历', keepAlive: false, permission: ['dashboard'] }
                    },
                ]
            },

            // {
            //     path: '/kaoji',
            //     name: 'kaojiList',
            //     component: PageView,
            //     redirect: '/kaoji/kaojiList',
            //     meta: {title: '七彩星级考试系统', icon: 'table', permission: ['qcxjexame', 'admin']},
            //     children: [
            //         {
            //             path: '/kaoji/kaojiList',
            //             name: 'KaojiList',
            //             component: () => import('@/views/kaoji/KaojiList'),
            //             meta: {title: '考试系统', keepAlive: true, permission: ['qcxjexame', 'admin']},
            //         },
            //     ]
            // },

            {
                path: '/qcxj',
                name: 'list',
                component: PageView,
                redirect: '/qcxj/order-index',
                meta: { title: '七彩星级', icon: 'table', hidden: true, permission: ['qcxj12', 'admin2', 'qcxjexame2'] },
                children: [{
                        path: '/apps/qcxj/ExameCenterList',
                        name: 'ExameCenter',
                        component: () =>
                            import ('@/views/qcxj/ExameCenterLayout'),
                        redirect: '/qcxj/ExameCenterList',
                        meta: { title: '考级中心考级点', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/ExameCenterList',
                                name: 'ExameCenterList',
                                component: () =>
                                    import ('@/views/qcxj/ExameCenterList'),
                                meta: { title: '考级中心考级点', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            // {
                            //     path: '/qcxj/KaojiApplyList',
                            //     name: 'KaojiApplyList',
                            //     component: () => import('@/views/qcxj/KaojiApplyList'),
                            //     meta: {title: '考级申报', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin']},
                            // },
                            // {
                            //     path: '/qcxj/KaoguanList',
                            //     name: 'KaoguanList',
                            //     component: () => import('@/views/qcxj/KaoguanList'),
                            //     meta: {title: '考官管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin']},
                            // }

                        ]
                    },
                    {
                        path: '/kaoji/kaojiList',
                        name: 'KaojiList',
                        component: () =>
                            import ('@/views/kaoji/KaojiList'),
                        meta: { title: '考试系统', keepAlive: true, permission: ['qcxjexame', 'admin'] },
                    },
                    // {
                    //     path: '/qcxj/shengshiRewardsList',
                    //     name: 'ShengshiRewardsList',
                    //     component: () =>
                    //         import ('@/views/qcxj/ShengshiRewardsList'),
                    //     meta: { title: '奖励结算', keepAlive: true, permission: ['qcxjexame', 'admin'] },
                    // },
                ]
            },

            {
                path: '/club',
                name: 'list',
                component: PageView,
                redirect: '/club/order-index',
                meta: { title: '星级俱乐部', icon: 'table', permission: ['qcxj1', 'admin'] },
                children: [{
                        path: '/apps/club/ClubIndex',
                        name: 'ClubIndex',
                        component: () =>
                            import ('@/views/club/ClubLayout'),
                        redirect: '/club/ClubList',
                        meta: { title: '星级俱乐部', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/club/ClubList',
                                name: 'ClubList',
                                component: () =>
                                    import ('@/views/club/ClubList'),
                                meta: { title: '星级俱乐部', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },{
                                path: '/club/ClubGradeList',
                                name: 'ClubGradeList',
                                component: () =>
                                    import ('@/views/club/ClubGradeList'),
                                meta: { title: '俱乐部升级', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            {
                                path: '/club/ClubGoodsList',
                                name: 'ClubGoodsList',
                                component: () =>
                                    import ('@/views/club/ClubGoodsList'),
                                meta: { title: '俱乐部建设商品', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            {
                                path: '/club/ClubJiansheList',
                                name: 'ClubJiansheList',
                                component: () =>
                                    import ('@/views/club/ClubJiansheList'),
                                meta: { title: '俱乐部建设订单', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },

                        ]
                    },
                    {
                        path: '/apps/cdakejian/DakejianIndex',
                        name: 'DakejianIndex',
                        component: () =>
                            import ('@/views/cdakejian/DakejianLayout'),
                        redirect: '/cdakejian/DakejianList',
                        meta: { title: '大课间申报', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/cdakejian/DakejianList',
                                name: 'CDakejianList',
                                component: () =>
                                    import ('@/views/cdakejian/DakejianList'),
                                meta: { title: '大课间申报', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },

                        ]
                    },
                    {
                        path: '/apps/sihao/SihaoIndex',
                        name: 'CSihaoIndex',
                        component: () =>
                            import ('@/views/sihao/SihaoLayout'),
                        redirect: '/csihao/SihaoList',
                        meta: { title: '四好运动员申报', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/csihao/SihaoList',
                                name: 'CSihaoList',
                                component: () =>
                                    import ('@/views/sihao/SihaoList'),
                                meta: { title: '四好运动员申报', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            {
                                path: '/csihao/SihaomemberList',
                                name: 'SihaoMemberList',
                                component: () =>
                                    import ('@/views/sihao/SihaoMemberList'),
                                meta: { title: '运动员人员管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                        ]
                    }
                ]
            },
            // class
            {
                path: '/huiyi',
                name: 'list',
                component: PageView,
                redirect: '/huiyi/huiyi-index',
                meta: { title: '会议培训', icon: 'table', permission: ['huiyi1', 'admin'] },
                children: [{
                        path: '/huiyi/SaiquList',
                        name: 'HuiyiSaiquList',
                        component: () =>
                            import ('@/views/huiyi/SettingLayout'),
                        redirect: '/huiyi/SaiquList',
                        meta: { title: '培训配置', keepAlive: true, hidden: true, permission: ['admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/SaiquList',
                                name: 'HuiyiSaiquList',
                                component: () =>
                                    import ('@/views/huiyi/SaiquList'),
                                meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },
                            {
                                path: '/huiyi/SaiquApplyList',
                                name: 'SaiquApplyList',
                                component: () =>
                                    import ('@/views/huiyi/SaiquApplyList'),
                                meta: { title: '申请办培训', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },
                            {
                                path: '/songpei/SaiquList',
                                name: 'SongpeiSaiquList',
                                component: () =>
                                    import ('@/views/songpei/SaiquList'),
                                meta: { title: '送培场次', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },
                        ]
                    },
                    {
                        path: '/huiyi/ApplyList',
                        name: 'HuiyiApplyList',
                        component: () =>
                            import ('@/views/huiyi/ApplyLayout'),
                        redirect: '/sai/ApplyList',
                        meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ApplyList',
                                name: 'HuiyiApplyList',
                                component: () =>
                                    import ('@/views/huiyi/ApplyList'),
                                meta: { title: '报名管理 ', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },{
                                path: '/huiyi/ApplyAreaList',
                                name: 'HuiyiApplyAreaList',
                                component: () =>
                                    import ('@/views/huiyi/ApplyAreaList'),
                                meta: { title: '报名管理 ', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },
                            {
                                path: '/huiyi/ApplyList',
                                name: 'HuiyiMemberList',
                                component: () =>
                                    import ('@/views/huiyi/MemberList'),
                                meta: { title: '人员管理', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },
                            {
                                path: '/songpei/ApplyList',
                                name: 'SongpeiApplyList',
                                component: () =>
                                    import ('@/views/songpei/ApplyList'),
                                meta: { title: '送培报名', keepAlive: true, hidden: true, permission: ['huiyi1', 'admin'] },
                            },

                        ]
                    },


                    {
                        path: '/cba/SaiquList',
                        name: 'CbaSaiquList',
                        component: () =>
                            import ('@/views/cba/SettingLayout'),
                        redirect: '/cba/SaiquList',
                        meta: { title: 'CBA培训班', keepAlive: true, hidden: true, permission: ['admin2'] },
                        hideChildrenInMenu: true,
                        children: [{
                            path: '/cba/SaiquList',
                            name: 'CbaSaiquList',
                            component: () =>
                                import ('@/views/cba/SaiquList'),
                            meta: { title: '场次管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                        }, ]
                    },
                    {
                        path: '/cba/ApplyList',
                        name: 'CbaApplyList',
                        component: () =>
                            import ('@/views/cba/ApplyLayout'),
                        redirect: '/sai/ApplyList',
                        meta: { title: 'CBA报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/cba/ApplyList',
                                name: 'CbaApplyList',
                                component: () =>
                                    import ('@/views/cba/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/cba/ApplyList',
                                name: 'CbaMemberList',
                                component: () =>
                                    import ('@/views/cba/MemberList'),
                                meta: { title: '人员管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            }

                        ]
                    },

                    {
                        path: '/apps/qcxj/KaoguanList',
                        name: 'KaoguanJiandu',
                        component: () =>
                            import ('@/views/qcxj/KaoguanjianduLayout'),
                        redirect: '/qcxj/KaoguanList',
                        meta: { title: '考官监督导师培训师', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/qcxj/KaoguanList',
                                name: 'KaoguanList',
                                component: () =>
                                    import ('@/views/qcxj/KaoguanList'),
                                meta: { title: '考官管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            {
                                path: '/qcxj/KaoguanMemberList',
                                name: 'KaoguanMemberList',
                                component: () =>
                                    import ('@/views/qcxj/KaoguanMemberList'),
                                meta: { title: '考官人员管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },{
                                path: '/qcxj/PeixunshiList',
                                name: 'PeixunshiList',
                                component: () =>
                                    import ('@/views/qcxj/PeixunshiList'),
                                meta: { title: '培训师批次管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },
                            {
                                path: '/qcxj/PeixunshiMemberList',
                                name: 'PeixunshiMemberList',
                                component: () =>
                                    import ('@/views/qcxj/PeixunshiMemberList'),
                                meta: { title: '培训师人员管理', keepAlive: true, hidden: true, permission: ['qcxj1', 'admin'] },
                            },

                        ]
                    },

                    {
                        path: '/huiyi/CpjlList',
                        name: 'CpjlList',
                        component: () =>
                            import ('@/views/huiyi/CpJlLayout'),
                        redirect: '/huiyi/ShengCaipanManage',
                        meta: { title: '裁判教练管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ShengCaipanManage',
                                name: 'ShengCaipanManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengCaipanManage'),
                                meta: { title: '省裁判报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/huiyi/ShengCaipanList',
                                name: 'ShengCaipanList',
                                component: () =>
                                    import ('@/views/huiyi/ShengCaipanList'),
                                meta: { title: '省裁判人员管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/huiyi/ShengJiaolianManage',
                                name: 'ShengJiaolianManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengJiaolianManage'),
                                meta: { title: '省教练报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/huiyi/ShengJiaolianList',
                                name: 'ShengJiaolianList',
                                component: () =>
                                    import ('@/views/huiyi/ShengJiaolianList'),
                                meta: { title: '省教练人员管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/huiyi/CpJlGrade',
                                name: 'CpJlGrade',
                                component: () =>
                                    import ('@/views/huiyi/CpJlGrade'),
                                meta: { title: '裁判教练等级查询', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            }

                        ]
                    },


                    {
                        path: '/huiyi/SaiquRewardList',
                        name: 'HuiyiRewardList',
                        component: () => import('@/views/huiyi/SaiquRewardList'),
                        redirect: '/huiyi/SaiquRewardList',
                        meta: {title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['wyhadmin']},
                        hideChildrenInMenu: true,
                        children: [
                            {
                                path: '/huiyi/SaiquRewardList',
                                name: 'HuiyiRewardList',
                                component: () => import('@/views/huiyi/SaiquRewardList'),
                                meta: {title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['wyhadmin']},
                            },
                        ],
                    
                    },

                    {
                        path: '/huiyi/DabiaoList',
                        name: 'DabiaoList',
                        component: () =>
                            import ('@/views/huiyi/DabiaoLayout'),
                        redirect: '/huiyi/ShengDabiaoManage',
                        meta: { title: '达标管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/huiyi/ShengDabiaoManage',
                                name: 'ShengDabiaoManage',
                                component: () =>
                                    import ('@/views/huiyi/ShengDabiaoManage'),
                                meta: { title: '达标报名管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            },
                            {
                                path: '/huiyi/ShengDabiaoList',
                                name: 'ShengDabiaoList',
                                component: () =>
                                    import ('@/views/huiyi/ShengDabiaoList'),
                                meta: { title: '达标人员管理', keepAlive: true, hidden: true, permission: ['cba1', 'admin'] },
                            }, 

                        ]
                    },
                    {
                        path: '/skill/applyList',
                        name: 'SkillLevel',
                        component: () =>
                            import ('@/views/skill/LevelLayout'),
                        redirect: '/skill/applyList',
                        meta: { title: '技术等级', keepAlive: true, hidden: true, permission: ['admin2'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/skill/applyList',
                                name: 'LevelApplyList',
                                component: () =>
                                    import ('@/views/skill/ApplyList'),
                                meta: { title: '申报批次', keepAlive: true, hidden: true, permission: ['admin'] },
                            },
                            {
                                path: '/skill/ApplyMemberList',
                                name: 'LevelApplyMemberList',
                                component: () =>
                                    import ('@/views/skill/ApplyMemberList'),
                                meta: { title: '申报人员', keepAlive: true, hidden: true, permission: ['admin'] },
                            },
                        ]
                    },
                ]
            },
            {
                path: '/sai',
                name: 'list',
                component: PageView,
                redirect: '/sai/sai-index',
                meta: { title: '赛事报名', icon: 'table', permission: ['caipan', 'admin'] },
                children: [{
                        path: '/sai/SaiquApplyList',
                        name: 'SaiSaiquApplyList',
                        component: () =>
                            import ('@/views/sai/ChouLayout'),
                        redirect: '/sai/SaiquApplyList',
                        meta: { title: '申请筹备', keepAlive: true, hidden: true, permission: ['admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/SaiquApplyList',
                                name: 'SaiSaiquApplyList',
                                component: () =>
                                    import ('@/views/sai/SaiquApplyList'),
                                meta: { title: '赛事申请', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/SaiquDataList',
                                name: 'SaiquDataList',
                                component: () =>
                                    import ('@/views/sai/SaiquDataList'),
                                meta: { title: '赛事筹备', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                        ]
                    },
                    {
                        path: '/sai/SaiquList',
                        name: 'SaiquList',
                        component: () =>
                            import ('@/views/sai/SettingLayout'),
                        redirect: '/sai/SaiquList',
                        meta: { title: '竞赛配置', keepAlive: true, hidden: true, permission: ['admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/SaiquList',
                                name: 'SaiquList',
                                component: () =>
                                    import ('@/views/sai/SaiquList'),
                                meta: { title: '赛区管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/SaijiList',
                                name: 'SaijiList',
                                component: () =>
                                    import ('@/views/sai/SaijiList'),
                                meta: { title: '赛季管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/SubjecttypeList',
                                name: 'SubjecttypeList',
                                component: () =>
                                    import ('@/views/sai/SubjecttypeList'),
                                meta: { title: '项目配置', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/SubjectmusicList',
                                name: 'SubjectmusicList',
                                component: () =>
                                    import ('@/views/sai/SubjectmusicList'),
                                meta: { title: '项目音乐', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/TopicList',
                                name: 'SaiTopicList',
                                component: () =>
                                    import ('@/views/sai/TopicList'),
                                meta: { title: '话题管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/SaiDateDetail',
                                name: 'SaiDateDetail',
                                component: () =>
                                    import ('@/views/sai/SaiDateDetail'),
                                meta: {
                                    title: '赛事日程',
                                    hidden: true,
                                    permission: ['admin']
                                }
                            },
                        ]
                    },
                    {
                        path: '/sai/SaiquRewardList',
                        name: 'SaiquRewardList',
                        component: () => import('@/views/sai/SaiquRewardList'),
                        redirect: '/sai/SaiquRewardList',
                        meta: {title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['wyhadmin']},
                        hideChildrenInMenu: true,
                        children: [
                            {
                                path: '/sai/SaiquRewardList',
                                name: 'SaiquRewardList',
                                component: () => import('@/views/sai/SaiquRewardList'),
                                meta: {title: '省市级结算奖励', keepAlive: true, hidden: true, permission: ['wyhadmin']},
                            },
                        ],
                    
                    },
                    {
                        path: '/sai/DanweiList',
                        name: 'DanweiList',
                        component: () =>
                            import ('@/views/sai/ApplyLayout'),
                        redirect: '/sai/DanweiList',
                        meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/DanweiList',
                                name: 'DanweiList',
                                component: () =>
                                    import ('@/views/sai/DanweiList'),
                                meta: { title: '单位备案', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/ApplyList',
                                name: 'ApplyList',
                                component: () =>
                                    import ('@/views/sai/ApplyList'),
                                meta: { title: '报名管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/ApplySubjectList',
                                name: 'ApplySubjectList',
                                component: () =>
                                    import ('@/views/sai/ApplySubjectList'),
                                meta: { title: '项目报名管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/ConfrimApplyList',
                                name: 'ConfrimApplyList',
                                component: () =>
                                    import ('@/views/sai/ConfrimApplyList'),
                                meta: { title: '信息确认管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            },
                            {
                                path: '/sai/TransApplyList',
                                name: 'TransApplyList',
                                component: () =>
                                    import ('@/views/sai/TransApplyList'),
                                meta: { title: '食宿信息管理', keepAlive: true, hidden: true, permission: ['qcxj', 'admin'] },
                            }

                        ]
                    },
                    {
                        path: '/sai/scoreStartList',
                        name: 'ScoreStartList',
                        component: () =>
                            import ('@/views/sai/ScoreLayout'),
                        redirect: '/sai/scoreStartList',
                        meta: { title: '评分系统', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/sai/scoreStartList',
                                name: 'ScoreStartList',
                                component: () =>
                                    import ('@/views/sai/ScoreStartList'),
                                meta: { title: '出场顺序', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
                            },
                            {
                                path: '/sai/scoreRun',
                                name: 'ScoreRun',
                                component: () =>
                                    import ('@/views/sai/ScoreRun'),
                                meta: { title: '正在进行', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
                            },
                            {
                                path: '/sai/scoreList',
                                name: 'ScoreList',
                                component: () =>
                                    import ('@/views/sai/ScoreList'),
                                meta: { title: '成绩查询', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
                            },
                            {
                                path: '/sai/caipanList',
                                name: 'CaipanList',
                                component: () =>
                                    import ('@/views/sai/CaipanList'),
                                meta: { title: '裁判员管理', keepAlive: true, hidden: true, permission: ['caipan','admin'] },
                            },
                            {
                                path: '/sai/jiaolianList',
                                name: 'JiaolianList',
                                component: () =>
                                    import ('@/views/sai/JiaolianList'),
                                meta: { title: '教练员管理', keepAlive: true, hidden: true, permission: ['caipan','admin'] },
                            },
                            {
                                path: '/sai/lingduiList',
                                name: 'LingduiList',
                                component: () =>
                                    import ('@/views/sai/LingduiList'),
                                meta: { title: '领队管理', keepAlive: true, hidden: true, permission: ['caipan','admin'] },
                            },
                        ]
                    }
                ]
            },
            {
                path: '/order/order-index',
                name: 'OrderIndex',
                redirect: '/order/order-list',
                component: () =>
                    import ('@/views/order/OrderIndex'),
                meta: {
                    title: '销售管理',
                    icon: 'table',
                    keepAlive: true,
                    hidden: true,
                    permission: ['order', 'admin']
                },
                children: [{
                        path: '/dashboard/orderanalysis',
                        name: 'OrderAnalysis',
                        component: () =>
                            import ('@/views/dashboard/OrderAnalysis'),
                        meta: { title: '销售分析页', keepAlive: false, permission: ['dashboard'] }
                    }, {
                        path: '/order/order-index',
                        name: 'OrderIndex',
                        redirect: '/order/order-list',
                        component: () =>
                            import ('@/views/order/OrderIndex'),
                        meta: {
                            title: '订单管理',
                            keepAlive: true,
                            hidden: true,
                            permission: ['order', 'admin']
                        },
                        hideChildrenInMenu: true,
                        children: [{
                                path: '/order/order-list',
                                name: 'OrderList',
                                component: () =>
                                    import ('@/views/order/OrderList'),
                                meta: {
                                    title: '订单管理',
                                    hidden: true,
                                    keepAlive: true,
                                    permission: ['order', 'admin']
                                }
                            },

                            {
                                path: '/order/order-detail',
                                name: 'OrderDetail',
                                component: () =>
                                    import ('@/views/order/OrderDetail'),
                                meta: {
                                    title: '订单详情',
                                    hidden: true,
                                    permission: ['order', 'admin']
                                }
                            },
                        ]
                    },
                    {
                        path: '/order/ConfigureList',
                        name: 'ConfigureList',
                        component: () =>
                            import ('@/views/order/ConfigureList'),
                        meta: { title: '销售配置', keepAlive: true, permission: ['admin'] }
                    },
                    {
                        path: '/order/orderUserList',
                        name: 'OrderUserList',
                        component: () =>
                            import ('@/views/order/OrderUserList'),
                        meta: { title: '销售统计', keepAlive: true, permission: ['admin'] }
                    },
                    {
                        path: '/order/withdrawalList',
                        name: 'WithdrawalList',
                        component: () =>
                            import ('@/views/order/WithdrawalList'),
                        meta: { title: '提现管理', keepAlive: true, permission: ['admin'] }
                    },

                ]
            },
            // forms

            // list

            // profile
            // result

            // Exception

            // account
        ]
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
        path: '/user',
        component: UserLayout,
        redirect: '/user/login',
        hidden: true,
        children: [{
                path: 'login',
                name: 'login',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/Login')
            },
            {
                path: 'register',
                name: 'register',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/Register')
            },
            {
                path: 'register-result',
                name: 'registerResult',
                component: () =>
                    import ( /* webpackChunkName: "user" */ '@/views/user/RegisterResult')
            }
        ]
    },

    {
        path: '/test',
        component: BlankLayout,
        redirect: '/test/home',
        children: [{
            path: 'home',
            name: 'TestHome',
            component: () =>
                import ('@/views/Home')
        }]
    },

    {
        path: '/404',
        component: () =>
            import ( /* webpackChunkName: "fail" */ '@/views/exception/404')
    },

    {
        path: '/sai/scoreForm',
        name: 'ScoreForm',
        component: () =>
            import ('@/views/sai/ScoreForm'),
        meta: { title: '评分页', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },
    {
        path: '/sai/scoreShow',
        name: 'ScoreShow',
        component: () =>
            import ('@/views/sai/ScoreShow'),
        meta: { title: '数据展示', keepAlive: true, hidden: true, permission: ['caipan', 'admin'] },
    },

]